var map = {
	"./gradient-female.svg": 30514,
	"./gradient-male.svg": 43859,
	"./gradient-neutral.svg": 59410,
	"./indigo-female.svg": 2848,
	"./indigo-male.svg": 57222,
	"./indigo-neutral.svg": 46573,
	"./royale-blue-female.svg": 81459,
	"./royale-blue-male.svg": 58993,
	"./royale-blue-neutral.svg": 77558,
	"./turquoise-female.svg": 11025,
	"./turquoise-male.svg": 42639,
	"./turquoise-neutral.svg": 53587
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27858;